import React, { useState } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import {
  WorkspacesOutlined as WorkspaceIcon,
  FolderOutlined as FolderIcon,
  ChevronRight as ChevronRightIcon,
  DriveFileMoveOutlined as DriveFileMoveIcon,
} from '@mui/icons-material';
import { alpha } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import MoveContractDialog from '../dialogs/MoveContractDialog';

const goldAccent = '#c9a96e';

const ContractLocationBreadcrumb = ({
  contractId,
  workspaceId,
  folderId,
  workspaceName,
  folderName,
  onMoved,
  variant = 'inline', // 'inline' | 'chip'
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const [dialogOpen, setDialogOpen] = useState(false);

  const isUnfiled = !workspaceId;

  return (
    <>
      <Box
        onClick={() => setDialogOpen(true)}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
          px: variant === 'chip' ? 1.25 : 0.75,
          py: variant === 'chip' ? 0.4 : 0.25,
          borderRadius: variant === 'chip' ? '999px' : '6px',
          bgcolor:
            variant === 'chip'
              ? alpha(theme.palette.text.secondary, 0.08)
              : 'transparent',
          cursor: 'pointer',
          maxWidth: 360,
          '&:hover': {
            bgcolor: alpha(goldAccent, 0.1),
            '& .move-icon': { opacity: 1 },
          },
        }}
        title={t('moveContract.tooltip', 'Click to move')}
      >
        <WorkspaceIcon sx={{ fontSize: 14, color: theme.palette.text.secondary }} />
        <Typography
          sx={{
            fontSize: '0.78rem',
            fontWeight: 500,
            color: isUnfiled
              ? theme.palette.text.disabled
              : theme.palette.text.secondary,
            fontStyle: isUnfiled ? 'italic' : 'normal',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {isUnfiled
            ? t('moveContract.unfiled', 'Unfiled')
            : workspaceName || '…'}
        </Typography>
        {folderId && (
          <>
            <ChevronRightIcon sx={{ fontSize: 14, color: theme.palette.text.disabled }} />
            <FolderIcon sx={{ fontSize: 14, color: theme.palette.text.secondary }} />
            <Typography
              sx={{
                fontSize: '0.78rem',
                fontWeight: 500,
                color: theme.palette.text.secondary,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {folderName || '…'}
            </Typography>
          </>
        )}
        <DriveFileMoveIcon
          className="move-icon"
          sx={{
            fontSize: 14,
            ml: 0.5,
            color: theme.palette.text.disabled,
            opacity: 0.5,
            transition: 'opacity 0.15s',
          }}
        />
      </Box>

      <MoveContractDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        contractIds={contractId ? [contractId] : []}
        currentWorkspaceId={workspaceId || null}
        currentFolderId={folderId || null}
        onMoved={onMoved}
      />
    </>
  );
};

export default ContractLocationBreadcrumb;
